import tw, { styled } from 'twin.macro';
import SearchIcon from '@components/icons/searchLargeIcon.svg';
import { h1Style } from '@student-coin/coinpaper-components';

export const Form = styled.form`
  ${tw`flex place-items-center overflow-hidden`};
  margin-bottom: 2rem;
`;

export const Icon = styled(SearchIcon)`
  margin-right: 1rem;
`;

export const Input = styled.input`
  ${tw`flex-auto`};
  ${h1Style};
  color: rgba(0, 0, 0, 0.6);
  background-color: transparent;

  :focus {
    outline: none;
  }
`;
